import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import L from 'leaflet';
import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';
import 'leaflet.markercluster';
import PopupContent from './PopUp';
import { Tooltip } from 'antd';

const MapGroup = ({ markers, mapRef }) => {
    let markerClusterGroup = null;

    useEffect(() => {
        // Initialize markerClusterGroup
        markerClusterGroup = L.markerClusterGroup();

        if (mapRef.current && mapRef.current.leafletElement) {
            const map = mapRef.current.leafletElement;
            // console.log(map, markerClusterGroup);

            // Check if map is available before adding clusters
            if (markers && map && markerClusterGroup) {
                // Add markers to the cluster
                markers.forEach(markerData => {
                    // console.log(markerData);

                    if (markerData && markerData.position) {
                        // console.log(markerData);
                        let marker = L.marker(markerData.position, { icon: markerData.icon });

                        // Generic permanent tooltip (e.g. asset count on a location marker)
                        if (markerData.tooltipHtml) {
                            marker.bindTooltip(markerData.tooltipHtml, {
                                permanent: true,
                                direction: 'top',
                                offset: [0, -12],
                                className: 'leaflet-location-count-tooltip',
                            });
                        }

                        if (markerData.popupContent) {
                            marker.bindPopup(markerData.popupContent);
                        } else if (markerData.dData && markerData.dId && markerData.deviceMaps) {

                            if (markerData.tooltip) {
                                // marker.bindTooltip(markerData.tooltip)
                                const tooltipContent = document.createElement('div')
                                ReactDOM.render(<Tooltip direction="bottom" offset={[0, 20]} opacity={1}
                                    permanent={true}><span style={{
                                        fontSize: 'small',
                                        fontWeight: 'bold'
                                    }}>
                                        <div>{markerData.deviceMaps.has(markerData.dId) ? markerData.deviceMaps.get(markerData.dId)['assetCode'] : '-'}</div>
                                        <div><small></small>({markerData.deviceMaps.has(markerData.dId) ? markerData.deviceMaps.get(markerData.dId)['altName'] : '-'}) {markerData.deviceMaps.has(markerData.dId) ? markerData.deviceMaps.get(markerData.dId)['ownerCode'] : '-'}</div>
                                    </span></Tooltip>, tooltipContent)
                                marker.bindTooltip(tooltipContent, {
                                    permanent: true, // Always visible
                                    direction: 'bottom',
                                    offset: [0, 20],
                                    className: 'leaflet-custom-tooltip', // Custom class for styling
                                });
                            }

                            const popupContent = document.createElement('div');
                            ReactDOM.render(
                                <PopupContent dData={markerData.dData} dId={markerData.dId} deviceMaps={markerData.deviceMaps} />,
                                popupContent
                            );
                            marker.bindPopup(popupContent);
                        }
                        markerClusterGroup.addLayer(marker);
                    }
                });
                map.addLayer(markerClusterGroup);

                // Cleanup on unmount
                return () => {
                    map.removeLayer(markerClusterGroup);
                };
            }
        }
    }, [markers, mapRef]);

    return null; // Since we're dealing with Leaflet directly, nothing to render in the DOM
};

export default MapGroup;
